import { render, staticRenderFns } from "./UserRoles.vue?vue&type=template&id=2ce4ea80&scoped=true"
import script from "./UserRoles.vue?vue&type=script&lang=js"
export * from "./UserRoles.vue?vue&type=script&lang=js"
import style0 from "./UserRoles.vue?vue&type=style&index=0&id=2ce4ea80&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ce4ea80",
  null
  
)

export default component.exports